import React, { Fragment } from 'react'
import Loading from '../Loading/Loading'
import Icon from '../Icon/Icon'
import cn from 'classnames'
import { iconPositionClassMap } from './classes'

/* eslint-disable react/prop-types */
export function generateButtonContent({ buttonIcon, children, iconPosition, buttonClassName }) {
  let buttonContent
  const buttonClasses = `c-button__content ${buttonClassName}`
  const iconPositionMap = {
    left: (
      <span className={buttonClasses}>
        {buttonIcon}
        <span className="c-button__text">{children}</span>
      </span>
    ),
    right: (
      <span className={buttonClasses}>
        <span className="c-button__text">{children}</span>
        {buttonIcon}
      </span>
    ),
    top: (
      <span className={buttonClasses}>
        <div>
          {buttonIcon}
        </div>
        <span className="c-button__text">{children}</span>
      </span>
    ),
  }

  if (buttonIcon) {
    buttonContent = iconPositionMap[iconPosition]
  } else {
    buttonContent = children
  }

  return buttonContent
}

export function generateButtonIcon({ isLoading, icon, iconPosition }) {
  let buttonIcon

  if (isLoading) {
    buttonIcon = <Loading className="c-button__loading" />
  } else if (icon) {
    buttonIcon = <Icon className={cn("c-button__icon", iconPositionClassMap[iconPosition])} icon={icon} />
  }

  return buttonIcon
}
/* eslint-enable react/prop-types */